<template>
	<el-dialog v-dialogDrag class="favorite-phrase" title="收藏话术" :visible.sync="visible" width="800px"
		:modal-append-to-body="false" :append-to-body="true" top="15vh" :before-close="onClose">
		<div class="phrase-header">
			<el-button type="primary" size="small" icon="el-icon-plus" @click="onAdd()">添加话术</el-button>
		</div>
		<el-table :data="phraseList" size="small" height="350" border>
			<el-table-column prop="sortOrder" label="排序" width="60" align="center"></el-table-column>
			<el-table-column prop="title" label="标题" width="150" show-overflow-tooltip></el-table-column>
			<el-table-column prop="content" label="内容">
				<template slot-scope="scope">
					<el-tooltip placement="top" effect="light" :open-delay="500">
						<div slot="content" class="tooltip-content">{{ scope.row.content }}</div>
						<div class="content-cell">{{ scope.row.content }}</div>
					</el-tooltip>
				</template>
			</el-table-column>
			<el-table-column label="操作" width="180" align="center">
				<template slot-scope="scope">
					<div class="action-btns">
						<el-button type="text" size="small" @click="onUse(scope.row)">使用</el-button>
						<el-button type="text" size="small" @click="onEdit(scope.row)">编辑</el-button>
						<el-button type="text" size="small" class="danger-text" @click="onDelete(scope.row)">删除</el-button>
					</div>
				</template>
			</el-table-column>
		</el-table>

		<!-- 添加/编辑话术弹窗 -->
		<el-dialog v-dialogDrag :title="isEdit ? '编辑话术' : '添加话术'" :visible.sync="editVisible" width="800px"
			:modal-append-to-body="false" :append-to-body="true" top="20vh" :before-close="onEditClose">
			<el-form :model="form" label-width="80px" :rules="editRules" ref="editForm" size="small">
				<el-form-item label="标题" prop="title">
					<el-input v-model="form.title" placeholder="请输入话术标题" maxlength="50"></el-input>
				</el-form-item>
				<el-form-item label="排序号" prop="sortOrder">
					<el-input-number v-model="form.sortOrder" :min="0" :max="999"></el-input-number>
				</el-form-item>
				<el-form-item label="内容" prop="content">
					<el-input v-model="form.content" type="textarea" :rows="5" placeholder="请输入话术内容" maxlength="500" show-word-limit></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="onEditClose()">取 消</el-button>
				<el-button type="primary" @click="onSave()">保 存</el-button>
			</span>
		</el-dialog>
	</el-dialog>
</template>

<script>
export default {
	name: "favoritePhrase",
	data() {
		return {
			visible: false,
			editVisible: false,
			isEdit: false,
			phraseList: [],
			form: {
				id: null,
				title: '',
				content: '',
				sortOrder: 0
			},
			editRules: {
				title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
				content: [{ required: true, message: '请输入内容', trigger: 'blur' }]
			}
		}
	},
	methods: {
		open() {
			this.visible = true;
			this.loadPhraseList();
		},
		onClose() {
			this.visible = false;
		},
		loadPhraseList() {
			this.$http({
				url: "/favoritePhrase/list",
				method: "get"
			}).then((data) => {
				this.phraseList = data;
			})
		},
		onAdd() {
			this.isEdit = false;
			this.form = {
				id: null,
				title: '',
				content: '',
				sortOrder: 0
			};
			this.editVisible = true;
		},
		onEdit(row) {
			this.isEdit = true;
			this.form = {
				id: row.id,
				title: row.title,
				content: row.content,
				sortOrder: row.sortOrder
			};
			this.editVisible = true;
		},
		onEditClose() {
			this.editVisible = false;
			this.$refs.editForm.resetFields();
		},
		onSave() {
			this.$refs.editForm.validate((valid) => {
				if (!valid) {
					return false;
				}
				const url = this.isEdit ? "/favoritePhrase/update" : "/favoritePhrase/add";
				const method = this.isEdit ? "put" : "post";
				this.$http({
					url: url,
					method: method,
					data: this.form
				}).then(() => {
					this.$message.success(this.isEdit ? "修改成功" : "添加成功");
					this.onEditClose();
					this.loadPhraseList();
				})
			});
		},
		onDelete(row) {
			this.$confirm('确定删除该话术吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: `/favoritePhrase/delete/${row.id}`,
					method: "delete"
				}).then(() => {
					this.$message.success("删除成功");
					this.loadPhraseList();
				})
			});
		},
		onUse(row) {
			this.$emit('use', row.content);
			this.onClose();
		}
	}
}
</script>

<style lang="scss" scoped>
.favorite-phrase {
	.phrase-header {
		margin-bottom: 15px;
		text-align: right;
	}

	.danger-text {
		color: #f56c6c;
	}

	.action-btns {
		display: flex;
		justify-content: center;
	}

	.content-cell {
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
}

.tooltip-content {
	max-width: 400px;
	white-space: pre-wrap;
	word-break: break-all;
	line-height: 1.5;
}
</style>
